import React from 'react';
import HeroSection from '../Components/home/HeroSection';
import AboutSection from '../Components/home/AboutSection';
import WhyUsSection from '../Components/home/WhyUsSection';
import ServicesSection from '../Components/home/ServicesSection';
import CTABanner from '../Components/CTABanner';

export default function Home() {
  return (
    <div>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <WhyUsSection />
      <CTABanner />
    </div>
  );
}